module.exports = __webpack_public_path__ + "static/media/BAckgroundOfferMobile.b86391cd.png";